{
    const template = `
        <style>
            :host {
                width: 100%;
                height: 100%;
                position: fixed;
                top: 0;
                left: 0;
                z-index: 100000;
            }
            :host(.dn) {
                display: none !important;
            }
            .dn {
                display: none !important;
            }
            .modal-body {
                width: 100%;
                height: 100%;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: center;
                    -ms-flex-pack: center;
                        justify-content: center;
                -webkit-box-align: center;
                    -ms-flex-align: center;
                        align-items: center;
                opacity: 0;
                -webkit-transition: 0.3s;
                transition: 0.3s;
            }
            .modal-bg {
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.7);
                position: absolute;
                top: 0;
                left: 0;
            }
            .modal-container {
                display:-webkit-box;
                display:-ms-flexbox;
                display:flex;
                width: 450px;
                min-height: 100px;
                max-height: 80vh;
                background-color: #fff;
                box-shadow: 0px 3px 10px rgba(0,0,0,0.2);
                border-radius: 10px;
                box-sizing: border-box;
                padding: 36px 16px 16px 16px;
                margin: 0px 20px;
                position: relative;
            }
            .close-btn {
                font-size: 16px;
                text-align: center;
                position: absolute;
                top: 8px;
                right: 12px;
                cursor: pointer;
                -webkit-transition: 0.3s;
                transition: 0.3s;
            }
            .close-btn:hover {
                transform: scale(0.8);
            }
            .modal-content {
                width: 100%;
                display:-webkit-box;
                display:-ms-flexbox;
                display:flex;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -ms-flex-direction: column;
                flex-direction: column;
                text-align: center;
            }
            .row-message {
                width: 100%;
                flex: 1 0 50%;
                font-size: 16px;
                font-weight: 400;
                color: #A5A5A5;
                letter-spacing:1px;
                overflow: auto;
            }
            ::slotted(.slot-message){
                color: #A5A5A5;
                font-size: 16px !important;
                text-align: center !important;
            }
            .row-message::-webkit-scrollbar {
                width: 5px;
            }
            .row-message::-webkit-scrollbar-thumb {
                background: #A5A5A5;
                border-radius: 10px;
            }
            .row-message::-webkit-scrollbar-track {
                background: #efefef;
                border-radius: 20px;
            }
            .row-action {
                width: 100%;
                flex-shrink: 1;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: center;
                    -ms-flex-pack: center;
                        justify-content: center;
                margin-top: 20px;
            }
            .opacity-1 {
                opacity: 1;
            }
            @media screen and (max-width:539px){
                .modal-container{
                    width: 100%;
                }
            }
            @keyframes modal-fade {
                from {
                    opacity: 0;
                    -webkit-transform: translate(0, -10%);
                    transform: translate(0, -10%);
                }
                to {
                    opacity: 1;
                    -webkit-transform: translate(0, 0);
                    transform: translate(0, 0);
                }
            }
            @keyframes bg-fade {
                from {opacity: 0;}
                to {opacity: 1;}
            }
            .modal-fade {
                -webkit-animation-name: modal-fade;
                animation: modal-fade .3s ease-out;
            }
            .bg-fade {
                -webkit-animation-name: bg-fade;
                animation: bg-fade .3s ease-out;
            }
        </style>
        <div class="modal-body">
            <div class="modal-bg bg-fade"></div>
            <div class="modal-container modal-fade">
                <div class="close-btn">
                    <svg class="close" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <line x2="12" y2="12" fill="none" stroke="#747474" stroke-width="1.5"/>
                        <line x1="12" y2="12" fill="none" stroke="#747474" stroke-width="1.5"/>
                    </svg>
                </div>
                <div class="modal-content">
                    <div class="row-message">
                        <slot name="row-message"></slot>
                    </div>
                    <div class="row-action">
                        <slot name="row-action"></slot>
                    </div>
                </div>
            </div>
        </div>`;
    customElements.define('eh-modal', class extends HTMLElement {
        constructor() {
            super();
            const shadowRoot = this.attachShadow({ mode: 'open' });
            shadowRoot.innerHTML = template;
            this.modalBody = this.shadowRoot.querySelector('.modal-body');
            this.modalBg = this.shadowRoot.querySelector('.modal-bg');
            this.modalContainer = this.shadowRoot.querySelector('.modal-container');
            this.rowAction = this.shadowRoot.querySelector("slot[name='row-action']");
            this.closeBtn = this.shadowRoot.querySelector('.close');
        }
        get open() {
            return this.getAttribute('open');
        }
        set open(newValue) {
            this.setAttribute('open', newValue);
        }
        get size() {
            return this.getAttribute('size');
        }
        set size(newValue) {
            this.setAttribute('size', newValue);
        }
        static get observedAttributes() {
            return ["open", "size"];
        }
        _closeModal() {
            this.setAttribute('open', 'false');
            this.setAttribute('size', 'unset');
        }
        attributeChangedCallback(name, oldValue, newValue) {
            switch(name){
                case 'open':
                    if(this.shadowRoot) {
                        const ehModal = this;
                        if(newValue == 'true') {
                            document.querySelector("eh-modal").classList.remove("dn");
                            ehModal.modalBody.classList.add('opacity-1');
                            if(!document.querySelector("eh-modal").querySelector("div[slot='row-action']")){
                                ehModal.rowAction.parentNode.classList.add('dn');
                            }
                            else{
                                ehModal.rowAction.parentNode.classList.remove('dn');
                            }
                        } 
                        else if(newValue === 'false' && oldValue !== null) {
                            ehModal.modalBody.classList.remove('opacity-1');
                            setTimeout(function(){
                                document.querySelector("eh-modal").classList.add("dn");
                                ehModal.innerHTML = '';
                            },200)
                        }
                    }
                    break;
                case 'size':
                    if(this.shadowRoot){
                        const ehModal = this;
                        if(oldValue !== null){
                            if(newValue !== 'unset'){
                                ehModal.modalContainer.style.width = newValue;
                            }
                            else{
                                setTimeout(function(){
                                    ehModal.modalContainer.removeAttribute('style');
                                },200)
                            }
                        }
                    }
                    break;
            }
        }
        connectedCallback() {
            const ehModal = this;
            if(!this.hasAttribute('open')){
                ehModal._closeModal();
                document.querySelector("eh-modal").classList.add("dn");
            }
            this.closeBtn.addEventListener('click', function(){
                ehModal._closeModal();
            });
            this.modalBg.addEventListener('click', function(){
                ehModal._closeModal();
            });
        }
    });
}
openModal = (msgOrTemp, size) => {
    if(msgOrTemp){
        // Method 1 : put template into slot
        if(document.getElementById(msgOrTemp)){
            let content = document.getElementById(msgOrTemp).innerHTML;
            document.querySelector('eh-modal').innerHTML = content;
        }
        // Method 1 : or HTML element / plain text
        else{
            document.querySelector('eh-modal').innerHTML = `<p class="slot-message" slot="row-message">` + msgOrTemp + `</p><div slot="row-action"></div>`
        }
    }
    if(size){
        document.querySelector('eh-modal').setAttribute('size', size);
    }
    document.querySelector('eh-modal').setAttribute('open', 'true');
};
closeModal = () => {
    document.querySelector('eh-modal').setAttribute('open', 'false');
    document.querySelector('eh-modal').setAttribute('size', 'unset');
};

/*  Method 2 : put template into slot and do something you want */

// const appendContent = (template) => {
//     let temp = document.getElementById(template);
//     //do something
//     document.querySelector('eh-modal').innerHTML = temp.innerHTML;
// }

// Method 1 : change Template content => openModal('tempId', 'size')
// Method 2 : change Template content => appendContent(tempId) => openModal('', 'size')
/* If you don't need flexible width to fit your content, size is not necessary. => openModal() */